














import { Vue, Component } from 'vue-property-decorator';
import DatasourceMenu from './datasource-menu.vue';
import DatasourceMenuCollect from './datasource-menu-collect.vue';
import DatasourceMenuProcess from './datasource-menu-process.vue';
import { namespace, State } from 'vuex-class';
const System = namespace('System');

@Component({
  components: { DatasourceMenu, DatasourceMenuCollect, DatasourceMenuProcess }
})
export default class DataLeft extends Vue {

  type = 0;

  @State MENU_INDENT: any;
  @System.State leftMenuIndent: any;
  @System.Mutation setLeftMenuIndent: any;

  created() {
    let path = this.$route.path;
    if (path.startsWith(`/data/datasource`)) {
      this.type = 1;
    } else if (path.startsWith(`/data/datacollect`)) {
      this.type = 2;
    } else if (path.startsWith(`/data/dataprocess`)) {
      this.type = 3;
    }
  }

  switchIndent() {
    this.setLeftMenuIndent();
  }
}
